/** @jsx jsx */
import { motion, TargetAndTransition } from "framer-motion";
import React from "react";
import { jsx } from "theme-ui";

const transition = {
  type: "spring",
  damping: 20,
  stiffness: 150,
  mass: 0.5,
};

type VariantKeys = "enter" | "exit";
export const revealAnimationDefaultVariants: Record<VariantKeys, TargetAndTransition> = {
  enter: {
    opacity: 1,
    height: "auto",
    transition,
    transitionEnd: {
      overflow: "visible",
    },
  },
  exit: {
    opacity: 0,
    height: 0,
    overflow: "hidden",
    transition,
  },
};

interface Props extends React.ComponentPropsWithoutRef<typeof motion.div> {
  animate?: VariantKeys;
  initial?: VariantKeys;
  variants?: Record<VariantKeys, any>;
}

export const RevealAnimation = React.forwardRef<HTMLDivElement, Props>(
  ({ children, variants = revealAnimationDefaultVariants, ...rest }, ref) => (
    <motion.div
      initial="exit"
      animate="enter"
      exit="exit"
      variants={variants}
      layout={true}
      data-animation="reveal"
      ref={ref}
      {...rest}>
      {children}
    </motion.div>
  ),
);
